// Module
var code = "<div class=\"[[ { 'hidden': !url } ]]\"> <div class=\"\"> <div class=\"[[ { 'hidden': !fallbackUrl } ]]\"> <iframe class=\"w-full aspect-video\" src=\"[[ fallbackUrl ]]\"></iframe> </div> </div> </div> ";
// Exports
export default code;